import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'HousingAssociationIssueListController',
            HousingAssociationIssueListController
        );

    /** @ngInject */
    function HousingAssociationIssueListController(
        $scope,
        ngDialog,
        HaEmployeeFactory,
        HousingAssociationsFactory
    ) {
        var vm = this;
        vm.pageSize = 10;

        $scope.$watch(
            function () {
                return vm.pageSize;
            },
            function () {
                var paramList = {
                    page: 1,
                    page_size: vm.pageSize,
                    active: true,
                };

                HaEmployeeFactory.readMe().then(function (me) {
                    HousingAssociationsFactory.readIssues(
                        me.data.organization.party_uuid,
                        paramList
                    ).then(function (response) {
                        vm.dataFromBackend = response.data.results;
                        vm.howManyElements = response.data.count;
                        vm.howManyCurrentElements =
                            response.data.results.length;
                    });
                });
            }
        );

        vm.readJournal = function (issue_id, is_open, index) {
            if (is_open == true) {
                HaEmployeeFactory.readMe().then(function (me) {
                    HousingAssociationsFactory.readJournal(
                        me.data.organization.party_uuid,
                        issue_id,
                        { page_size: 100 }
                    ).then(function (response) {
                        vm.dataFromBackend[index].journal =
                            response.data.results;
                    });
                });
            }
        };

        vm.readMore = function () {
            vm.pageSize = vm.pageSize + 5;
        };

        vm.openReportIssueWindow = function () {
            ngDialog.open({
                template: 'haIssueFormDialog',
                className: 'dialog-theme',
                controller: 'HaIssueFormController',
                controllerAs: 'HaIssueFormCtrl',
            });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/housing_association_issue_list/housing_association_issue_list.controller.ts